// ============================================================================
// EASY-EDIT COLOUR SCHEME
// Change any hex value below, save the file, refresh your browser. That's it.
//
// This is the ONLY file you need to edit to change the app's colour scheme. Every colour in the
// app reads from here - including ag-grid (the data-table library), which normally uses a
// completely different styling mechanism (CSS custom properties, not Chakra props) and would
// otherwise need its own separate edit - see applyAgGridColours.ts, which copies these same
// values into ag-grid's CSS variables at startup so you never have to touch two files to change
// one colour.
// ============================================================================
export const themeColours = {
  // Overall
  appBackground: "#f7f4f9",
  defaultText: "#1A202C",

  // Navbar
  navbarBackground: "#10325e",
  navbarBackgroundSecondary: "#001c40",
  navbarIcon: "#FFFFFF",

  // ActionBar
  actionBarBackground: "#FFFFFF",
  actionBarBorder: "#10325e",
  actionBarButtonEnabled: "#48936b",
  actionBarButtonDisabled: "#A0AEC0",

  // AG-Grid
  agGridContainerBackground: "#FFFFFF",
  agGridInternalBackground: "#ebf6f1",
  agGridHeaderBar: "#a7d4ec",
  agGridGroupingBar: "#58afde",
  agGridFilterBar: "#a7d4ec",

  // PreFilter (components/PreFilter.tsx) - the Run button + parameter bar above a filtered grid,
  // used by ReportRunner and (eventually) other pages like DocLibrary
  preFilterBackground: "#EDEDED",
  preFilterBorder: "#D0D0D0",
};
